import { render, staticRenderFns } from "./GoodToKnowForm.vue?vue&type=template&id=9dc342a6&"
import script from "./GoodToKnowForm.vue?vue&type=script&lang=js&"
export * from "./GoodToKnowForm.vue?vue&type=script&lang=js&"
import style0 from "./GoodToKnowForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports